import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Col as AntdCol } from 'antd';

const StyledCol = styled(AntdCol)`
  ${p => p.marginBottom && `margin-bottom: ${p.marginBottom}px;`}
  ${p => p.marginTop && `margin-top: ${p.marginTop}px;`}
  ${p => p.marginLeft && `margin-left: ${p.marginLeft}px;`}
  ${p => p.marginRight && `margin-right: ${p.marginRight}px;`}
  ${p => p.paddingBottom && `padding-bottom: ${p.paddingBottom}px;`}
  ${p => p.paddingTop && `padding-top: ${p.paddingTop}px;`}
  ${p => p.paddingLeft && `padding-left: ${p.paddingLeft}px;`}
  ${p => p.paddingRight && `padding-right: ${p.paddingRight}px;`}
`;

const Col = ({
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  paddingBottom,
  paddingTop,
  paddingLeft,
  paddingRight,
  ...rest
}) =>
  <StyledCol
    marginBottom={marginBottom}
    marginTop={marginTop}
    marginLeft={marginLeft}
    marginRight={marginRight}
    paddingBottom={paddingBottom}
    paddingTop={paddingTop}
    paddingLeft={paddingLeft}
    paddingRight={paddingRight}
    {...rest}
  />;

Col.propTypes = {
  marginBottom: PropTypes.number,
  marginTop: PropTypes.number,
  marginLeft: PropTypes.number,
  marginRight: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingTop: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number,
};
export default Col;
